import { getBoundsOfDistance } from 'geolib'

import { createSelector } from '@app/utils/createSelector'

import { createAddress } from '@app/packages/geo/Address'
import type { AddressKind } from '@app/packages/geo/MapBounds'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'

import { profilePlaceBundleResultSelector, profilePlaceNameResultSelector } from '@app/store/slices/profile_place'
import { rawSearchParamsSelector } from '@app/store/slices/search/params'

export { rawSearchParamsSelector } from '@app/store/slices/search/params'
export { searchIdsSelector, searchMetaSelector } from '@app/store/slices/search/results'

export const defaultSearchAddressResultSelector = createSelector(
  [profilePlaceNameResultSelector, profilePlaceBundleResultSelector],
  (labelResult, dataResult) =>
    createLoadable(c => {
      const label = c.unwrap(labelResult)
      const data = c.unwrap(dataResult)
      const bounds = getBoundsOfDistance(data.place.attributes, 10000)
      return createAddress({
        label,
        kind: 'locality' satisfies AddressKind,
        location: {
          lat: data.place.attributes.latitude,
          lon: data.place.attributes.longitude,
        },
        bounds: {
          bottomLeft: { lat: bounds[0].latitude, lon: bounds[0].longitude },
          topRight: { lat: bounds[1].latitude, lon: bounds[1].longitude },
        },
      })
    })
)

export const searchParamsResultSelector = createSelector([rawSearchParamsSelector, defaultSearchAddressResultSelector], (params, addressResult) =>
  createLoadable(c => {
    const address = c.unwrap(addressResult)
    if (params.address) return params
    return { ...params, address: address ?? undefined }
  })
)
